import { createContext, useContext, useEffect, useReducer } from "react";
import reducer from "./course_reducer";
import { BASE_URL } from "../../Config/Config";

 const  Appcontext = createContext();
const API = `${BASE_URL}/coursemaster/`;
 
const intialstate = {
    isloading : false,
    courses : [],
   
}
const  Courseprovider = ({children})=>{
const [state ,  dispath] = useReducer(reducer , intialstate); 

 const getcourse =  async (URL)=>{
    dispath({type:'SET_LOADING'});
     try {
        const response = await fetch(URL,{
            method: "GET",
            headers: {
              'content-type': "application/json"
            },
            credentials: "include",
          });


         if(!response){
            console.log("faild fatching data ");
         }

         else{
            const coursedata =  await response.json();
            dispath({type:"SET_API_DATA", payload:coursedata.data })
         }
        
    } 
    catch (error) {
          console.log(error);
    }
    
 }
 useEffect(()=>{
    getcourse(API);
 } , []);
  return (
            <Appcontext.Provider  value={{...state}}>
             {children   }
            </Appcontext.Provider>
  
  )}

  // custom Hooks....  
  const Usecoursecontext = ()=>{
    return useContext(Appcontext);
  }



  export {Courseprovider,Usecoursecontext , Appcontext}